import type { BalanceSheetId } from "@inrev/common";
import type { StatementMatrixViewModel } from "../../ui/FinancialDataGrid";
import { mergeStatementWithEdits } from "./mergeStatementWithEdits";

export const mergeBalanceSheetWithEdits = (args: {
	viewModel: StatementMatrixViewModel<BalanceSheetId>;
}): StatementMatrixViewModel<BalanceSheetId> =>
	mergeStatementWithEdits({
		...args,
		shouldRollup: (row) => (row.children?.length ?? 0) > 0,
		rollupLiveChildren: (row) => row.children ?? [],
		resolveSubtotalChild: (_row, liveChildren) => {
			const subtotalIndex = liveChildren.findIndex((c) => c.kind === "subtotal");
			return subtotalIndex >= 0 ? liveChildren[subtotalIndex] : null;
		},
		evaluateDerivedRows: true,
	});
